export default __webpack_public_path__ + "i18n/translations/translation-pt.2b49b46e.json";